import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-time-question',
  templateUrl: './time-question.component.html',
  styleUrls: ['./time-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TimeQuestionComponent implements OnInit {

  @Input() question: QQQuestionViewModel;
  timeSlots = timeSlots("09:00", "17:00", 30);

  constructor() { }

  ngOnInit() {
    this.timeSlots = timeSlots(this.question.options?.StartTime ?? "09:00",
      this.question.options?.EndTime ?? "17:00",
      this.question.options?.Step ?? 30);
    if (!this.question.editingValue)
      this.question.editingValue = "";
  }

  async onChange() {
    if (this.question.editingValue !== null)
      await this.save();
  }

  async save() {
    this.question.error = null;
    const time = this.question.editingValue;
    await this.question.setAnswer(String(time), true);
  }

}

function timeSlots(startTime: string, endTime: string, step: number): string[] {
  const result: string[] = [];
  let current = new Date(`2000-01-01T${startTime}`);
  const end = new Date(`2000-01-01T${endTime}`);

  while (current <= end) {
    result.push(current.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }));
    current.setMinutes(current.getMinutes() + step);
  }
  return result;
}
